/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useState } from "react";
import { useCallback } from "react";
import { Env } from "../../controller/constant";
import ChannelProfileContext from "./channelProfileContext";

const ChannelProfileState = (props) => {
    const [description, setDescription] = useState("");
    const [file, setFile] = useState(undefined);
    const [category, setCategory] = useState("");
    const [categoryKey, setCategoryKey] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [channelNo, setChannelNo] = useState("");
    const [displayName, setdisplayName] = useState("");
    const [Website, setWebsite] = useState("");

    const getChannelProfile = useCallback(async (val) => {
        console.log("getChannelProfile: ", channelNo)
        const response = await axios.get(Env.baseApiCallURL + "/business/fetch-meta-business-profile/" + channelNo, {}, {})
        if (response.status === 200) {
            console.log("business_profile: " + JSON.stringify(response.data.data[0]))
            const datavalue = response.data.data[0]
            setAddress(datavalue.address)
            setEmail(datavalue.email)
            setWebsite(datavalue.websites)
            setDescription(datavalue.description)
            setFile(datavalue.profile_picture_url)
            setCategoryKey(datavalue.vertical)
            let index = val.findIndex(ob => ob.value === datavalue.vertical)
            setCategory(val[index].text)

        }
    }, [channelNo])


    const updateProfile = useCallback(async (val) => {
        const response = await axios.post(Env.baseApiCallURL + "/business/update-meta-business-profile/" + channelNo, val, {})
        return response
    }, [channelNo])



    return (
        <ChannelProfileContext.Provider
            value={{
                getChannelProfile,
                file,
                setFile,
                description,
                setDescription,
                category,
                setCategory,
                categoryKey,
                setCategoryKey,
                address,
                setAddress,
                email,
                setEmail,
                Website,
                setWebsite,
                setChannelNo,
                channelNo,
                displayName,
                updateProfile,
                setdisplayName
            }}>
            {props.children}
        </ChannelProfileContext.Provider>
    )
}

export default ChannelProfileState;